import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

export const AuthorWrapper = styled.div`
  width: 100%;
  padding: 16px 0;
  margin-bottom: 32px;
  border-bottom: 1px solid #d2d6da;
  border-top: 1px solid #d2d6da;

  @media (${mediaQuery.tablet}) {
    width: auto;
    margin: 0 0 32px;
  }

  ${media.xs`
    margin: 0 16px 32px;
    padding: 16px 0;
    border-left: none;
    border-right: none;
  `}
`;

export const AuthorContent = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const AuthorAvatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 1px solid #d2d6da;
  overflow: hidden;
  .lazy-image-wrapper {
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
`;

export const RightAuthorContent = styled.div`
  width: 646px;
  padding-left: 24px;

  ${media.lg`
    flex:1;
  `};
`;

export const ShowMoreButton = styled.a`
  margin-top: 8px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`;

export const AuthorInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  ${media.xs`
    flex-direction: column;
    margin-bottom: 16px;
  `};

  a {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const AuthorName = styled.h3`
  margin: 0;
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;

  ${media.xs`
    margin-bottom: 8px;
  `};
`;

export const AuthorDescription = styled.p<{ disableLineClamp: boolean }>`
  display: -webkit-box;
  line-height: normal;
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  -webkit-line-clamp: ${(props) => (props.disableLineClamp ? 'unset' : 3)};
  -webkit-box-orient: vertical;
  overflow: ${(props) => (props.disableLineClamp ? 'inherit' : 'hidden')};
`;
